// Homepage hero playlist: seekable progress bar for each song (playback itself is handled by lane-card-audio).
(() => {
  const formatTime = (seconds) => {
    if (!Number.isFinite(seconds) || seconds < 0) return '0:00';
    const whole = Math.floor(seconds);
    return `${Math.floor(whole / 60)}:${String(whole % 60).padStart(2, '0')}`;
  };

  const setUp = (item) => {
    const audio = item.querySelector('audio');
    const progress = item.querySelector('[data-lane-playlist-progress]');
    const range = progress?.querySelector('input[type="range"]');
    const time = progress?.querySelector('[data-lane-playlist-time]');
    if (!audio || !range || !time || item.dataset.lanePlaylistReady) return;
    item.dataset.lanePlaylistReady = 'true';

    let dragging = false;

    const paint = (percent, seconds) => {
      range.value = String(percent);
      range.style.setProperty('--lane-progress', `${percent}%`);
      range.setAttribute('aria-valuetext', `${formatTime(seconds)} of ${formatTime(audio.duration)}`);
      time.textContent = `${formatTime(seconds)} / ${formatTime(audio.duration)}`;
    };

    const update = () => {
      if (dragging) return;
      const duration = audio.duration;
      const percent = Number.isFinite(duration) && duration > 0 ? (audio.currentTime / duration) * 100 : 0;
      paint(percent, audio.currentTime);
    };

    audio.addEventListener('play', () => {
      progress.hidden = false;
      update();
    });
    ['timeupdate', 'loadedmetadata', 'durationchange', 'seeked'].forEach((name) => audio.addEventListener(name, update));

    range.addEventListener('input', () => {
      dragging = true;
      const duration = audio.duration;
      const percent = Number(range.value);
      paint(percent, Number.isFinite(duration) ? (percent / 100) * duration : 0);
    });

    // Arrow keys skip 5 seconds instead of the range's tiny default step.
    range.addEventListener('keydown', (event) => {
      const direction = { ArrowRight: 1, ArrowUp: 1, ArrowLeft: -1, ArrowDown: -1 }[event.key];
      if (!direction || !Number.isFinite(audio.duration)) return;
      event.preventDefault();
      audio.currentTime = Math.min(Math.max(audio.currentTime + direction * 5, 0), audio.duration);
    });

    range.addEventListener('change', () => {
      const duration = audio.duration;
      if (Number.isFinite(duration) && duration > 0) audio.currentTime = (Number(range.value) / 100) * duration;
      dragging = false;
      update();
    });
  };

  const init = (root = document) => root.querySelectorAll('.lane-home-playlist__item').forEach(setUp);

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
